// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { InvoicePaymentModel } from "@adl/App/Handlers/InvoicePayment/LoadInvoicePayment";
import { get, post } from "@insite/client-framework/Services/ApiService";

export interface InvoicePaymentCollectionModel {
    invoicePayment: any;
    isLoading: any;
    makePayment: any;
    paymentMethod: any;
    lateFee: number;
    expDates: any;
    invoiceAmountSummation: any;
    invoicePaymentConfirmation: {
        isLoading: { [key: string]: boolean };
        byId: { [key: string]: InvoicePaymentModel };
        errorStatusCodeById: { [key: string]: number };
    };
}

const invoicesUrl = "/api/v1/invoices";

export async function getOpenInvoices(parameter?: any) {
    const invoicesCollection = await get<any>(invoicesUrl, parameter);
    return invoicesCollection;
}

const makeInvoicePaymentUrl = "api/adl/invoicepayment/MakePayment";

export async function makeInvoicePayment(parameter?: any) {
    const invoicesCollection = await post<any>(makeInvoicePaymentUrl, parameter);
    return invoicesCollection;
}

const getExpirationDatesUrl = "api/adl/invoicepayment/PopulateExpirationDates";

export async function getExpirationDates() {
    const getExpirationDates = await get<any>(getExpirationDatesUrl);
    return getExpirationDates;
}

const getInvoiceAmountSummationUrl = "api/adl/invoicepayment/GetInvoiceAmountSummation";

export async function getInvoiceAmountSummation() {
    const invoiceAmountSummation = await get<any>(getInvoiceAmountSummationUrl);
    return invoiceAmountSummation;
}

const getInvoicePaymentUrl = "api/adl/invoicepayment/Confirmation";
export async function getInvoicePayment(parameter: { id: string }) {
    const invoicePayment = await get<any>(`${getInvoicePaymentUrl}/${parameter.id}`);
    return invoicePayment;
}
